import { Controller } from "react-hook-form";
import { Input } from "ui";

import { PrivacyFormAtomProps } from "../PrivacyForm.types";

import styles from "../PrivacyForm.module.scss";

const DescriptionField = ({
  control,
  name,
  label,
  placeholder
}: PrivacyFormAtomProps) => {
  return (
    <div className={styles.form_input}>
      <Controller
        control={control}
        name={name}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={label}
            placeholder={placeholder}
            errorMessage={error?.message}
            data-testid={`content-privacyAndTerms--${name}`}
            asTag="textarea"
          />
        )}
      />
    </div>
  );
};

export default DescriptionField;
